<template>
  <div class="row main-row" id="myMain">
  
    <div class="hero" style="max-height:600px">
    
      <div class="hero-text">
       
      
      <h1 style="margin-bottom: 0px!important; padding-bottom:0px!important;" class="title-text text-center">Find the perfect Sitter</h1>
        <div class="row find-container" style="margin:0; padding:0" v-if="countryDataComp.CountryId">
          <div class="col-sm-12 col-md-12 col-lg-12 col-xs-12" style="margin:0; padding:0" >
            <p class="hidden-xs text-center" style="margin-top: 0px;font-size:15px; color:#656565">Cat and dog boarding just got awesome </p>
            <p class=" hidden-sm hidden-md hidden-lg text-center " style="font-size:14px; margin-top: 0px;color:#656565">Cat and dog boarding just got awesome </p>
            <div class="form-group" style="margin:1px; padding:1px">

              <div  class='form-group'>
                <select @keyup.enter="searchSitters()" id="citySelect" required name="citySelect" v-if="citiesList " class="form-control input-text"  placeholder="Select City" v-model="queryDataComp.cityId">
                  <option value="null" disabled selected hidden>Select a City</option>
                  <option v-for="city in citiesList" v-bind:value="city.CityId">
                    {{city.CityName}}
                  </option>
                </select>
              </div>
              
            </div>
          </div>
          
         <div style="margin:1px; padding:1px">
            <button class="btn btn-success btn-lg btn-block btn-title-big hidden-xs fix-button  hidden-sm" @mouseover="active=true" @mouseleave="active=false"  @click="searchSitters()"> Search   <i  class="animated bounceIn fa fa-paw "/></button>
            <button class="btn btn-success btn-lg btn-block btn-title-big hidden-md hidden-lg"  @mouseover="active=true" @mouseleave="active=false" @click="searchSitters()"> Search <i class="animated bounceIn fa fa-paw "/></button>
        </div>
        
        
      </div>
     
        </div>
      
    </div>

    
   
    <div class="container">
    
    <h2 class="text-center ">The next level of cat and dog boarding  </h2>
    <hr>
    <div class="col-xs-12 col-sm-3">
        <img alt="Dupaws Cute Pet" class="img img-responsive" src="https://www.dupaws.com/services/images/site/petsbag.jpg" height="300"/>
        
    </div>
    <div class="col-xs-12 col-sm-9">
    <p style="font-size: medium">
    Are you always traveling with limited options on who to watch your pet? We know it can be a daunting task for pet parents to find a trusted and passionate person to look for their pets, thats why we created Dupaws.
    </p>
    <br>
    <p style="font-size: medium">Dupaws is an online platform that allows you to quickly find a pet buddy in your area or community to stay with your pet while you are away to ensure stress free stay for your pet and peace of mind for you, think of it as the airbnb for pets.</p>
    </div>
    

    
    </div>
        <nav class="navbar navbar-default nav-bottom paw">
        <div class="text-center">
              <i class="fa fa-star fa-2x inline" style="color:#ffd118;margin-top:10px; margin-bottom:10px;" v-for="n in 5"/>
               <p >({{staycationDataComp.ReviewsCount}}) Pet parent verified reviews</p>
               </div>
      </nav>
      <br>

      <div class="text-center">
          <div class="container">
            <p style="font-size: medium">
            <i class="fa fa-quote-left fa-1x"></i> She was great, welcoming, friendly, sending me videos of Lucky to know how is he doing, it truly shows her love for dogs ... i was feeling comfortable leaving my Lucky with her. I could see my dog was enjoying there. Surely will contact her again. <i class="fa fa-quote-right fa-1x"></i></p>
            </div>
            <p>Lucie N</p>
            <a href="https://www.dupaws.com/pub/reviews">Read more reviews</a>
            <hr>
      </div>               
     
    <br>
   <div class="container" v-if="staycationDataComp.SittersImages!=null">

      <div class="col-sm-6 ">
      <h3 class="text-center">Recently joined Pet Buddies</h3>
    <flickity ref="flickity" :options="flickityOptions">
      <div class="carousel-cell-sitter" v-for="item in staycationDataComp.SittersImages">
        <img alt="Dupaws Cute Pet" class="carousel-image" :src="item.Path"/>
        <h2 class="centered"><span class="span-centered">{{item.Name}}</span></h2>
      </div>
    
    
    </flickity>
    </div>
    <br class="hidden-sm hidden-md hidden-lg">
    <div class="col-sm-6 ">
      <h3 class="text-center">Recently completed a stay</h3>
       <flickity ref="flickity" :options="flickityOptions">
        <div class="carousel-cell-pet" v-for="item in staycationDataComp.PetsImages">
          <img alt="Dupaws Cute Pet" class="carousel-image" :src="item.Path" />
          <h2 class="centered"><span class="span-centered">{{item.Name}}</span></h2>
        </div>
      
    </flickity>
    </div>
    
    </div>
    
    <br>
  
      <nav class="navbar navbar-default nav-bottom paw">
        <h2 class="text-center ">How it works</h2>
      </nav>

      <div style="padding-bottom:20px; padding-top:20px; background-color: rgba(255, 254, 254, 0.72);" class="container-fluid">
          <div class="col-sm-4">
            <div  class="step1">
                
            </div>
            <div class="text-center">
              <small  class="text-muted text-center">Go through profiles, compare ratings, prices & more</small>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="step2">

            </div>
            <div class="col-sm-10 col-sm-offset-1">
            <div class="text-center">
              <small  class="text-muted text-center">Schedule a meet and greet in person before confirming</small>
            </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="step3">

            </div>
            <div>
            <div class="text-center">
              <small class=" text-muted text-center">Choose terms of payment that suits you and the sitter.</small>
            </div>
            </div>
            
          </div>
        
      </div>
      <div>
      </div>
      <nav class="navbar navbar-default nav-bottom paw">
        <h2 class="text-center ">Featured In</h2>
      </nav>

      <div style="padding-bottom:20px; padding-top:20px; background-color: rgba(255, 254, 254, 0.72);" class="container">
          <div  class="col-xs-4 col-sm-2 remove-margins">
           <div  class="news1">
            </div>
          </div>
         <div  class="col-xs-4 col-sm-2 remove-margins">
             <div class="news2">

            </div>
          </div>
         <div  class="col-xs-4 col-sm-2 remove-margins">
             <div class="news3">

            </div>
          
          </div>
         <div  class="col-xs-4 col-sm-2 remove-margins">
             <div class="news4">

            </div>
         
          </div>
         <div  class="col-xs-4 col-sm-2 remove-margins">
             <div class="news5">

            </div>
         
          </div>
         <div  class="col-xs-4 col-sm-2 remove-margins">
             <div class="news6">

            </div>
         
          </div>
        
        
      </div>
      <div>
        <strong><p style="font-size:larger;margin-top:15px;" class="text-center ">Why Dupaws?</p></strong>
        <div class="container">
        
          <hr style="margin-top:5px;">
        </div>
        <div class="container">
        <p style="font-size:medium" class="hidden-md hidden-lg" >Dupaws primary focus is making it more convenient and affordable to find a real home for your cat or dog, we facilitate all the needed details that both pet parent or pet sitter needs, including creating cat or dog profiles, multiple bookings tracking, online chat, sms and email notifications, customer reviews, pricing and more.</p>
        <p style="font-size:medium" class="text-center hidden-sm hidden-xs" >Dupaws primary focus is making it more convenient and affordable to find a real home for your cat or dog, we facilitate all the needed details that both pet parent or pet sitter needs, including creating cat or dog profiles, multiple bookings tracking, online chat, sms and email notifications, customer reviews, pricing and more.</p>
       
       
        <div class="col-xs-12 col-sm-10 col-sm-offset-1 col-md-6 col-md-offset-3">
          <hr>
          <div class="text-center">
          <h5  class="text-center">Pamper your furry baby</h5>
          </div>
             <div class="col-xs-12 col-sm-8 col-sm-offset-2">
          <button @click="searchSitters()" style="font-size:24px!important"  class="btn btn-success btn-lg btn-block "  >Find Sitters <i class="fa fa-paw"/></button>
          <div class="text-center">
          <small class="text-center">or</small>
          </div>
        </div>
        
        <div  class="col-xs-12 col-sm-8 col-sm-offset-2">
        <div class="text-center">
         <h5 class="text-center">Join our awesome community</h5>
         </div>
          <button @click="goBecomeSitter()" style="font-size:24px!important"  class="btn btn-info btn-lg btn-block "  >Become a Sitter</button>
        </div>
        
        </div>
        
          
        </div>
        <br>
        </div>
        </div>
      
      


  </div>


</template>

<script>


import Flickity from 'vue-flickity';
import store from '../data/store.js'
import commonApi from '../services/commonApi'
export default {
  name: 'home' , 
  data() {
    return {
      flickityOptions: {
        fullscreen:false,
        pageDots: false,
        wrapAround: true,
        dragThreshold:35,
        draggable: false,
        lazyload:1
      
      },
      updatedNow: false,
      active:false,
      share:false,
      message:false,
      scrollPosition: ''
    };
  },
  updated(){
      var self = this
    
    $('#citySelect').focus(function (){
            self.scrollPosition = window.scrollY
            
      });
    $('#citySelect').blur(function (){
            // $(window).animate({ scrollTop: this.scrollPosition }, "slow");
            self.$SmoothScroll(self.scrollPosition, 350)
            
      });
     self.$nextTick(function() {
     $('#citySelect').focus(function (){
            self.scrollPosition = window.scrollY
            
      });
    $('#citySelect').blur(function (){
            // $(window).animate({ scrollTop: this.scrollPosition }, "slow");
            self.$SmoothScroll(self.scrollPosition, 350)
            
      });
    });
  },
  components: {
    Flickity
  },
  watch:{
        'queryDataComp.regionId': function(regionId){
          var self = this
          console.log('changed')
          if (regionId && regionId!=0 && self.countryDataComp)
            commonApi.getCitiesList(self.countryDataComp.CountryId, regionId)
        },
        'queryDataComp.cityId': function(cityId){
          var self = this
          this.queryDataComp.currentPage = 0;
          this.queryDataComp.areaId = null;
        }
  },
  mounted(){
    self = this;
    this.$ga.page(this.$router)
    self.$nextTick(function() {
      
      
      $('#homeDatePickerTo').datepicker({
                autoclose: true,
                format: 'yyyy-mm-dd',
                todayHighlight: true,
                ignoreReadyonly: true,
                allowInputToggle: true,
                beforeShowDay: function(date) {
                       if (!self.queryDataComp.start){
                        return date.valueOf() >= new Date();
                        } else {
                          return date.valueOf() >= moment(self.queryDataComp.start)
                      }
                  
                },
    }).on('changeDate', function (selected){   //When changing date..
            self.queryDataComp.end =  moment(selected.date).format('YYYY-MM-DD')                
    });


    $('#homeDatePickerFrom').datepicker({
            autoclose: true,
            format: 'yyyy-mm-dd',
            todayHighlight: true,
            ignoreReadyonly: true,
            allowInputToggle: true,
            beforeShowDay: function(date) {
                return moment(date).tz("Asia/Dubai").add(1,"days") >= moment().tz("Asia/Dubai");
                
                
    },
    }).on('changeDate', function (selected){  //When changing date..
                        self.queryDataComp.start =  moment(selected.date).format('YYYY-MM-DD')
                        if (!self.queryDataComp.end){   //Fill end date to start date if it's empty only                        
                          $('#homeDatePickerTo').datepicker('update', self.queryDataComp.start)
                          self.queryDataComp.end = self.queryDataComp.start

                        } else if (self.queryDataComp.end<self.queryDataComp.start){
                          
                          $('#homeDatePickerTo').datepicker('update', self.queryDataComp.start)
                          self.queryDataComp.end = self.queryDataComp.start
                          
                        } else {  //This step is needed if customer goes back in date on homeDatePickerFrom to allow for beforeShowDay refresh.
                           $('#homeDatePickerTo').datepicker('destroy')
                           $('#homeDatePickerTo').datepicker({
                                        autoclose: true,
                                        format: 'yyyy-mm-dd',
                                        todayHighlight: true,
                                        beforeShowDay: function(date) {
                                                  return date.valueOf() >= moment(self.queryDataComp.start)
                                                 }
                                        }).on('changeDate', function (selected){   //When changing date..
                                          self.queryDataComp.end =  moment(selected.date).format('YYYY-MM-DD')                
                            });
                        }
    });
  });  // end of nextTick!
   


  },
  methods:
  {
   goBecomeSitter(){
      this.$router.push({path: '/become-a-sitter'})
  },
   next() {
      this.$refs.flickity.next();
    },
    previous() {
      this.$refs.flickity.previous();
    },
   
    sendFacebook: function(){
        FB.ui({
            method: 'send',
            link: 'https://www.dupaws.com',
        });
    },
    shareFacebook: function(myQuote){
      FB.ui({
         method: 'share',
         href: 'https://www.dupaws.com',
         quote: myQuote,
         hashtag: '#dupaws',
         mobile_iframe: true
         }, function(response){
                  if (response && !response.error_message){
                    
                  }
                  else {
                  
         }
      });
  },
  searchSitters: function(){
      this.$router.push({path: '/findsitters'})
    },
  
  searchDogWalkers: function(){
      store.getters.QueryData.serviceType = 6
      this.$router.push({path: '/findsitters'})
    },
  
  },
  
  computed: {
    updatedComp: function(){
      return this.updatedNow
    },
    regionsList: function(){
        return store.getters.RegionsList
    },
     citiesList: function(){
            return store.getters.CitiesList
     },
     queryDataComp: function(){
        return store.getters.QueryData
     },
     countryDataComp: function(){
       return store.getters.CountryData
     },
     staycationDataComp: function(){
       return store.getters.StaycationData
     },
     myQuoteComp: function(){
       return 'Airbnb for pets now available in ' + this.countryDataComp.CountryName
     }
     
  },
  
  
}

</script>


<style scoped>

.support-image{
      background-image: url("./Sitters/images/support.png");
}



.find-container{
  max-width:650px;
  min-width:300px;
}

.nav-bottom{
  margin-bottom: 0px;
}

.ButtonActive{
  background-color: red;
}

.ButtonInActive{
  background-color:blue;
}


.tinted { filter: brightness(88%);}

p{
  font-size:18px;
}

.carousel-cell-sitter {
  width: 100%; /* full width */
  height: 300px;
  
  /* center images in cells with flexbox */
  display: flex;
  align-items: center;
  justify-content: center;
      
    /* background-size: unset; */
}

.carousel-cell-pet {
  width: 100%; /* full width */
  height: 300px;
  
  /* center images in cells with flexbox */
  display: flex;
  align-items: center;
  justify-content: center;
      
    /* background-size: unset; */
}

.carousel-image {
  display: block;
  height: 300px;
  border-radius: 5px;
  /* set min-width,
     allow images to determine cell width */
  min-width: 150px;
  max-width: 100%;
  /* vertically center */


}


.carousel.is-fullscreen .carousel-image {
  height: auto;
  max-height: 100%;
}


.paw{ 
   background-image: url("./Sitters/images/paw.png");
    background-size: contain;
    width: 100%;
    
    
}

.form-control[disabled], .form-control[readonly], fieldset[disabled] .form-control {
    background-color: #ffffff;
    opacity: 1;
}


.step1{
    background-image: url("./Sitters/images/step1.png");
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center top;
    height: 100px;
    width: 100%;
    

}

.news1{
    background-image: url("https://www.dupaws.com/services/images/newsite/5.png");
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center top;
    height: 80px;
    width: 100%;
}

.news2{
    background-image: url("https://www.dupaws.com/services/images/newsite/2.png");
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center top;
    height: 80px;
    width: 100%;
}

.news3{
    background-image: url("https://www.dupaws.com/services/images/newsite/3.png");
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center top;
    height: 80px;
    width: 100%;
}

.news4{
    background-image: url("https://www.dupaws.com/services/images/newsite/4.png");
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center top;
    height: 80px;
    width: 100%;
}

.news5{
    background-image: url("https://www.dupaws.com/services/images/newsite/1.png");
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center top;
    height: 80px;
    width: 100%;
}

.news6{
    background-image: url("https://www.dupaws.com/services/images/newsite/6.png");
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center top;
    height: 80px;
    width: 100%;
}

.card {
    /* Add shadows to create the "card" effect */
    transition: 0.3s;
    border:1px;
    border-radius: 5px;
    border-style: solid;
    border-color: #c7c6c6;
    
}

.step2{
    background-image: url("./Sitters/images/step2.png");
    background-repeat: no-repeat; 
    background-size: contain;
    background-position: center top;
    height: 100px;
    width: 100%;
    

}

.step3{
    background-image: url("./Sitters/images/step3.png");
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center top;
    height: 100px;
    width: 100%;
    

}


.main-row{
  margin-left: 0px;
  margin-right: 0px
}



.btn-title-big{
  font-size:28px !important;
      
  font-family: 'Yanone Kaffeesatz', sans-serif;
}


.centered {
    position: absolute;
    top: 80%;
    left: 50%;
    transform: translate(-50%, -50%);
    color:white;
}

.span-centered { 
   color: white; 
   font: bold 24px/45px Helvetica, Sans-Serif; 
   letter-spacing: -1px;  
   background: rgb(0, 0, 0); /* fallback color */
   background: rgba(0, 0, 0, 0.7);
   padding: 10px; 
   border-radius:10px;
}

.paw-footer{
    background-image: url(/static/img/paw.1322fb8.png);
    background-size: 70px;
    width: 100%;
    
}

.inline {
  display: inline-block ;
  vertical-align: baseline;
  padding-right: 1px
}



.paw-footer{
     background-image: url("../components/Sitters/images/paw.png");
    background-size: 70px;
    width: 100%;
    
}

</style>


// WEBPACK FOOTER //
// Home.vue?708b00bc